import { Component, EventEmitter, Input, Output } from "@angular/core"

@Component({
	selector: "app-modal-multi-building",
	templateUrl: "./modal-multi-building.component.html",
	styleUrls: ["./modal-multi-building.component.scss"]
})
export class ModalMultiBuildingComponent {
	@Input() buildings: any[]
	@Output() selectBuilding: EventEmitter<any> = new EventEmitter()
}
